import { gql } from "@apollo/client";

const DeleteUserDeviceMutation = gql`
  mutation DeleteUserDeviceMutation($id: BigInt!) {
    deleteUserDeviceById(input: { id: $id }) {
      deletedUserDeviceId
    }
  }
`;

const hash = "ddeb5bbd6c3abddb23bfbdec4317a7b637534c0cc38615b094e9210c4bb26777";

export { DeleteUserDeviceMutation, hash };
